import React from 'react';
import { Field, Fieldset, Label, Legend } from '@headlessui/react';

import Checkbox from '../Checkbox/Checkbox';

type CheckboxOptionType = {
    label: string;
    value: string | number;
    name?: string;
}

interface Props {
    title?: string,
    options: CheckboxOptionType[];
    onChange: (checked: boolean, value: CheckboxOptionType['value']) => void;
    checkedValues: Array<string | number>;
}

/**
 * Fenders a list of checkboxes.
 */
const CheckboxGroup = ({ title, options, onChange, checkedValues }: Props) => (
    <Fieldset className="space-y-050">
        {/* TODO: Style the legend */}
        {title ? <Legend className="type-small-caps">{title}</Legend> : null}
        {(options.map((option) => {
            const checked = checkedValues.includes(option.value);

            const handleChange = (isChecked: boolean) => {
                onChange(isChecked, option.value)
            }

            return (
                <Field
                    key={option.label}
                    className="flex items-center"
                >
                    <Checkbox checked={checked} onChange={handleChange} name={option.name} />
                    <Label className="flex-grow pl-050 ">{option.label}</Label>
                </Field>
            );
        }))}
    </Fieldset>
);

export default CheckboxGroup;
